module.exports = __webpack_public_path__ + "static/img/预设话术@2x2.0dc014a7.png";